import type { TranslationObj } from "$/utils/lang"

import { EProductTypeInternalName, type IEnrollmentModel } from "@/3514/types"
import type { IJwtTokenPairModel } from "@/models/jwt"
import type { Language } from "@/models/state"

interface IUserModuleShort {
    id: number
    rank: number
}

enum EUserRole {
    Participant = "participant",
    Coach = "coach",
    Manager = "manager",
    Assistant = "executive_assistant"
}

interface ISharedUserModel {
    id: number
    email: string
    firstName: string
    lastName: string
    photo: string | null
    jwtPair: IJwtTokenPairModel
    languageCode: Language
    userId: number
}

interface IUserParticipantModel extends ISharedUserModel {
    role: EUserRole.Participant
    //
    isCoachingPlanAvailable: boolean
    browserSessionTtl: number | null
    /**
     * @deprecated used only for coach-select onboarding step after likert submission; should be moved to the appropriate call
     */
    isCoachMatchingFinished: boolean
    cohortName: string
    cohortLanguages: TranslationObj
    doesCohortExist: boolean
    /**
     * @deprecated only 'id' & 'rank' field are used, need to be cleaned up
     */
    currentModule: IEnrollmentModel
    /**
     * @deprecated used only on self-enrollment page, better to create a dedicated call there
     */
    isEligibleSelectModule: boolean
    enrollments: IEnrollmentModel[]
    areGuestSessionsEnabled: boolean
    isDiagnosticPresent: boolean
    isReflectionPresent: boolean
    areNotCompletedSurveysPresent: boolean
    areSurveysPresent: boolean
    isSubUser: boolean
    journeyLength: number
    areModulesAvailable: boolean
    modulesShortList: IUserModuleShort[]
    /**
     * @deprecated used only on offboarding page; should be moved onto a separate call
     */
    isOffboardingPassed: boolean
    isOnboardingFinished: boolean
    /**
     * @deprecated used only in post-session modal on accordion being expanded, potential candidate for removal
     */
    organizationName: string
    organizationSlug: string
    isPracticeLabAvailable: boolean
    productType: EProductTypeInternalName
    isUnexpectedAuth: boolean
}

interface IUserCoachModel extends ISharedUserModel {
    role: EUserRole.Coach
    //
    isAccountsRelinkingRequired: boolean
    isCoachingPlanAvailable: boolean
    isCalendarSetupConfirmed: boolean
    areSubUsersPresent: boolean
}

interface IUserManagerModel extends ISharedUserModel {
    role: EUserRole.Manager
}

interface IUserAssistantModel extends ISharedUserModel {
    role: EUserRole.Assistant
}

type IUserModel = IUserParticipantModel | IUserCoachModel | IUserManagerModel | IUserAssistantModel

export { EUserRole }
export type {
    IUserModuleShort,
    ISharedUserModel,
    IUserModel,
    IUserParticipantModel,
    IUserCoachModel,
    IUserManagerModel,
    IUserAssistantModel
}
